import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=1da4f892&"
import script from "./Treatments.vue?vue&type=script&lang=js&"
export * from "./Treatments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports